import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcClickableModalTooltipClasses,
} from '@dxp-module/themes'

const clickableModalTooltipStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcClickableModalTooltipClasses
>(
  () => ({
    tooltipIconButton: {
      padding: '2px 0 0 5px',
    },
    contentContainer: {
      padding: '15px 15px 20px 15px',
    },
    contentMargin: {
      marginTop: 20,
    },
  }),
  { name: 'FC_ClickableModalTooltip' }
)

export default clickableModalTooltipStyles
